import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { startSpinner, finishSpinner } from "../ui/spinner";

const contactosWebTraerStart = () => ({
  type: types.movimientosTraerStart,
});

export const contactosWebTraerSuccess = (payload) => {
  return {
    type: types.contactosWebTraerSuccess,
    payload: payload,
  };
};



export const traerContactosWeb = () => {
  return async (dispatch) => {
    dispatch(startSpinner());
    dispatch(contactosWebTraerStart());
    
    const response = await fetchConToken(`BandejaInteresados/`)
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const lista = await response.json();
      dispatch(contactosWebTraerSuccess(lista))
    }
    dispatch(finishSpinner());
  };
};

export const traerContactosConfirmados = () => {
    return async (dispatch) => {
        dispatch({
            type: types.contactosValidos,
        })
    };
};

export const traerContactosPendientes = () => {
    return async (dispatch) => {
        dispatch({
            type: types.contactosPendientes,
        })
    };
  };

export const buscarContactoWeb = (text) =>dispatch=>{
    dispatch({
      type:types.buscarContactosWeb,
      payload:text
    });
 
 }
 